import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'
import positions from './positions'
export default combineReducers({
  routing: routerReducer,
  positions
})



// WEBPACK FOOTER //
// ./src/modules/index.js